import React, { useEffect, useState } from "react";
import { MainContainer, Section } from "./styles";
import Typography from "../../../../components/Typography";
import { JsonEditor } from "json-edit-react";
import { Post } from "../../../Enterprise/modules/Post/types";
import { mockPost } from "./mock";
import useAdmin from "../../hooks/useAdmin";
import { Divider, Result, Table } from "antd";
import Button from "../../../../components/Button";
import ThemeColors from "../../../../themes/colors";
import { Column } from "../../../../themes/globalStyle";
import { postService } from "../../../../services/modules/post";
import { openNotification } from "../../../../components/Notification";
import { ImageContainer, SelectItemImg } from "../../styles";
import SelectItem from "../../../../assets/svg/select.svg";
import { columns } from "./table";

const PostContent: React.FC = (): JSX.Element => {
  const { adminState } = useAdmin();

  const [postCreationData, setPostCreationData] = useState<Post[]>(mockPost);
  const [postList, setPostList] = useState<Post[]>();
  const [isLoading, setIsLoading] = useState<boolean>();

  const fetchPosts = () => {
    postService
      .getPosts(adminState.selectedEnterprise)
      .then((response) => setPostList(response));
  };

  const handleCreatePost = async () => {
    setIsLoading(true);

    const tasks = postCreationData.map(
      (post) =>
        adminState.selectedEnterprise &&
        postService
          .createPost(adminState.selectedEnterprise, {
            ...post,
            keyword:
              typeof post.keyword === "object"
                ? post.keyword.map((k) => k).join(", ")
                : "",
            subaccount_id: adminState.selectedEnterprise,
            main_account_id: adminState.selectedMainAccountId,
          })
          .finally(() => setIsLoading(false))
    );

    try {
      await Promise.all(tasks);
      openNotification(
        "topRight",
        "Tarefa",
        "Postagens criadas com sucesso!",
        "success"
      );
      setIsLoading(false);
      fetchPosts();
    } catch (error) {
      openNotification(
        "topRight",
        "Tarefa",
        "Erro ao criar as postagens!",
        "error"
      );
    }
  };

  useEffect(() => {
    adminState.selectedEnterprise && fetchPosts();
  }, [adminState.selectedEnterprise]);

  return (
    <MainContainer>
      <Section>
        <Typography
          text={`Briefing - ${adminState.selectedEnterprise || "Sem id"}`}
          size="huge"
          color="Black500"
          weight={700}
        />
        {adminState.selectedEnterprise ? (
          <>
            <JsonEditor
              data={postCreationData}
              theme="monoDark"
              collapse={1}
              setData={(data) => setPostCreationData(data as Post[])}
            />
            <Button
              size="middle"
              borderRadius="0.5rem"
              style={{ width: "fit-content" }}
              backgroundColor={ThemeColors.Black500}
              onClick={handleCreatePost}
              loading={isLoading}
            >
              <Typography
                text="Criar"
                size="medium"
                color="Bg300"
                weight={400}
              />
            </Button>
          </>
        ) : (
          <ImageContainer>
            <Result
              icon={
                <SelectItemImg src={SelectItem} style={{ height: "8rem" }} />
              }
              title="Área de postagens"
              subTitle="Por favor, selecione um projeto para criar as postagens."
            />
          </ImageContainer>
        )}
      </Section>
      <Divider />
      {adminState.selectedEnterprise && (
        <Section>
          <Typography
            text={"Postagens"}
            size="huge"
            color="Black500"
            weight={700}
          />
          <Column>
            <Table
              dataSource={postList || []}
              columns={columns}
              loading={!postList}
            />
          </Column>
        </Section>
      )}
    </MainContainer>
  );
};

export default PostContent;
